
import React, { useEffect, useState } from 'react';
import { AutoComplete, Input } from "antd";
import { ReactComponent as SearchIcon } from '../../../../../../assets/icons/search_icon.gov.svg';
import '../../../../../../styles/pages/_searchBarComponent.scss';
import { useDispatch, useSelector } from 'react-redux';
import { getSelectedUsersData } from 'store/adminPanel/actions';



const SearchComponent = (props) => {
    const dispatch = useDispatch();
    const prefix = <SearchIcon />;
    const { Search } = Input;
    const [searchTerm, setSearchTerm] = useState("");

    const enterSearch = (value) => {
        if(value){
            dispatch(getSelectedUsersData(value))
            .then(selectedUser => {
                if(Object.keys(selectedUser).length){
                    props.setDisplayedUsers([selectedUser]);
                    props.setChecked(false);
                    props.setSelectedUsers([]);
                }
            });
        }
        
    };

    useEffect(()=>{
        if(searchTerm.length>0) {
            const filteredUsers = props.allUsers.filter( user =>
                user.id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                user.firstName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                user.lastName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                user.email?.toLowerCase().includes(searchTerm.toLowerCase())
            )
            props.setDisplayedUsers(filteredUsers);
            props.setChecked(false);
            props.setSelectedUsers([]);
        } else {
            props.setDisplayedUsers(props.allUsers);
            props.setChecked(false);
            props.setSelectedUsers([]);
        }
    },[searchTerm])

    return (
        <div>
            <Search
                onPressEnter={event => enterSearch(event.target.value) && props.setCurrentPage(1)}
                onChange={event => setSearchTerm(event.target.value) && props.setCurrentPage(1)}
                bordered={false}
                allowClear={true}
                prefix={prefix}
                className="sayt-input-filter input-filter"
                size="large"
                placeholder="Search with User ID, First Name, Last Name, Email (Press Enter if the user exists but does not appear in the table.)"
                enterButton
            />
        </div>
    );
};

export default SearchComponent;
